import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

type ConnectingToDappDisplayProps = {
  /**
   * Callback to call when the user clicks the "Cancel" button to cancel the pending connection to a dapp
   */
  onPendingDappConnectionCancelled: () => void;
};

/**
 * Component to display to the user that a connection to a dapp is pending
 */
export function ConnectingToDappDisplay(
  props: ConnectingToDappDisplayProps
): React.ReactElement {
  return (
    <div className="flex flex-col items-center gap-4">
      <Loader2 className="mt-2 h-8 w-8 animate-spin text-zinc-700" />
      <p className="mb-2 text-[20px] font-medium text-zinc-700">
        Waiting for the dapp to connect...
      </p>

      <div className="w-full rounded-[20px] border border-zinc-200 bg-zinc-50">
        <div className="rounded-t-[20px] bg-neutral-900 px-6 py-3">
          <p className="text-[16px] font-medium text-white">
            Trouble connecting?
          </p>
        </div>
        <div className="space-y-4 px-6 py-5">
          <p className="text-[14px] leading-[20px] text-zinc-700">
            If the dapp doesn&apos;t connect, the link probably expired.
            <br />
            Try again with a new connection link for the dapp you&apos;re trying
            to connect.
          </p>
          <p className="text-[12px] leading-[20px] text-zinc-500">
            Still stuck?{' '}
            <a
              href="https://support.perawallet.app/en/article/resolving-walletconnect-issues-1tolptm/"
              target="_blank"
              rel="noreferrer"
              className="underline"
            >
              Click here
            </a>{' '}
            for WalletConnect troubleshooting tips.
          </p>
        </div>
      </div>

      <Button
        variant="outline"
        onClick={props.onPendingDappConnectionCancelled}
        className="mt-1"
      >
        Cancel
      </Button>
    </div>
  );
}
